module.exports = __webpack_public_path__ + "static/media/BlueCross.685a763b.webp";